'use client'

import ActiveLink from './active-link'
import {usePathname} from 'next/navigation'
import {favPagePath} from '@app/[lang]/(common-header-footer)/tags/constants'
import s from './style.module.scss'
import clsx from 'clsx'
import CometLink from '@app/components/custom-links/comet-link'
import AnimateOnVisibleWrapper from '../sidebar-tags-container/animate-visiblity/animate-visiblity-wrapper'

type Props = {
  emoji: string
  name: string
  isMobile: boolean
  className?: string
}

const FavSidebarLink = ({emoji, name, isMobile, className}: Props) => {
  const path = usePathname()
  const isActive = path?.includes(`/${favPagePath}`)
  return (
    <AnimateOnVisibleWrapper index={0}>
      <CometLink href={`/${favPagePath}`} className={clsx(s.sidebar_tag, s.fav_sidebar_tag, className)}>
        <ActiveLink isActive={!!isActive} />
        <span className={s.emoji}>{emoji}</span>
        <span
          className={clsx(s.sidebar_tag_text, {
            [s.active_tag]: isActive,
            [s.hovered]: !isActive,
            [s.desktop_sidebar_fav_text]: !isMobile,
            ['group-hover:!flex -mb-1']: !isMobile,
          })}
        >
          {name}
        </span>
      </CometLink>
    </AnimateOnVisibleWrapper>
  )
}

export default FavSidebarLink
